module.exports = __webpack_public_path__ + "static/3-4b7827c39801cfa8367acc8a26eaea10.jpg";